import * as React from 'react';
import { formStyles } from 'styles/formStyles';
import { AddIcon } from '@fluentui/react-icons';

interface RechnungPositionenHeaderProps {
    allowEdit?: boolean;
    onAdd?: () => void;
}

export const RechnungPositionenHeader: React.FC<RechnungPositionenHeaderProps> = ({ allowEdit = false, onAdd }) => {
    return (
        <thead className={formStyles.positionenTable}>
            <tr className={formStyles.positionenHeader}>
                <td className={formStyles.positionenNrCell}>Pos.</td>
                <td className={formStyles.positionenArtikelGruppeCell}>Art. Grp.</td>
                <td className={formStyles.positionenArtikelNrCell}>Art. Nr.</td>
                <td className={formStyles.positionenTextCell}>Text</td>
                <td className={formStyles.positionenEinhCell}>Einh</td>
                <td className={formStyles.positionenMoneyCell}>Menge LS</td>
                <td className={formStyles.positionenMoneyCell}>Menge AB</td>
                <td className={formStyles.positionenMoneyCell}>EK-Preis</td>
                <td className={formStyles.positionenMoneyCell}>VK-Preis</td>
                <td className={formStyles.positionenMoneyCell}>VK-Netto</td>
                {/* <td className={formStyles.positionenMoneyCell}>VK-Brutto</td> */}
                <td className={formStyles.positionenMwstCell}>MwSt.</td>
                {allowEdit && (
                    <>
                        <td className={formStyles.positionenActionCell} />
                        <td className={formStyles.positionenActionCell} />
                        <td className={formStyles.positionenActionCell}>
                            <AddIcon className={formStyles.positionenAction} onClick={onAdd} />
                        </td>
                    </>
                )}
            </tr>
        </thead>
    );
};
